import create from 'zustand';

interface SettingsStoreState {
  platformSetting: PlatformSetting;
  setPlatformSetting: (info?: Partial<PlatformSetting>) => void;
}

type PlatformSetting = {
  showBreadcrumb: boolean;
  menuWidth: number;
  grayMode: boolean;
  weaknessMode: boolean;
  transition: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

const useSettingsStore = create<SettingsStoreState>((set) => ({
  platformSetting: {
    showBreadcrumb: true,
    menuWidth: 160,
    grayMode: false,
    weaknessMode: false,
    transition: false,
  },
  setPlatformSetting: (info: Partial<PlatformSetting> = {}) =>
    set((state) => ({
      platformSetting: { ...state.platformSetting, ...info },
    })),
}));

export default useSettingsStore;
